export { default } from "./SubjectStemFilledIcon";
